import './PackageVCLP.css';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../../utils';
import React from 'react';
import defaultPackageImg from '../image/default-package-img.jpg'


const url = `${API_BASE_URL}/master/assets/uploads/`;

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px 0',
    boxSizing: 'border-box',
    width: "100%",
  },
  content: {
    textAlign: 'center',
    maxWidth: '600px',
    backgroundColor: 'white',
    borderRadius: '16px',
    margin: ' auto ',
    padding: '40px 20px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '2.5rem',
    color: '#6a1b9a',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    marginBottom: '30px',
    lineHeight: '1.6',
  },
  button: {
    backgroundColor: '#6a1b9a',
    color: 'white',
    padding: '12px 24px',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
  },
  image: {
    marginTop: '30px',
    width: '250px',
    opacity: 0.9,
  },
};

const PackageCard = ({ PackageData }) => {
  console.log("PackageData", PackageData);


  return (
    <>
      <div className='vcdp-package-card'>
        <div className='vcdp-package-card-conainer'>
          <div className='vcdp-package-card-image-wrapper'>
            {PackageData.packageThumbnail?.trim() || PackageData.thumbnail?.trim() ? (
              <img
                src={
                  PackageData.packageThumbnail?.trim()
                    ? url + PackageData.packageThumbnail
                    : url + PackageData.thumbnail
                }
                alt={PackageData.name}
              />
            ) : (
              <img src={defaultPackageImg} alt="default-image" />
            )}


          </div>
          <div className='vcdp-package-card-text'>
            <div className='vcdp-package-card-header'>
              {PackageData.clubLogo &&
                <div className='vcdp-package-card-logo'>
                  <img src={url + PackageData.clubLogo} alt="" />
                </div>
              }
              <div className='vcdp-package-card-club-name'>
                <h1>{PackageData.title}</h1>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>

  );
}

export default React.memo(function Package({ partypackages = [], isvenue, isPartyPackage }) {


  const venueUrl = (item) => {
    return `/${item.cityName?.replace(/ /g, "-")}/${item.areaName?.replace(/ /g, "-")}/${item.clubName
      ?.trim()
      .split(/ +/)
      .join("-")
      .replace(/ /g, "-")
      .toLowerCase()}/${item.title
        ?.split("+")
        .map((part) => part.trim().replace(/ /g, "-"))
        .join("-")
        .toLowerCase()}`;
  };


  const partypackageUrl = (item) => {
    return `/package/${item.cityName?.replace(/ /g, "-")}/${item.areaName?.replace(/ /g, "-")}/${item.clubName
      ?.trim()
      .split(/ +/)
      .join("-")
      .replace(/ /g, "-")
      .toLowerCase()}/${item.title
        ?.split("+")
        .map((part) => part.trim().replace(/ /g, "-"))
        .join("-")
        .toLowerCase()}`;
  };

    function generateClubUrl(clubName, cityName, areaName, title) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}/${format(title)}`;
    }


  return (
    <div style={styles.container}>
      {partypackages?.length === 0 ? (
        <div style={styles.container}>
          <div style={styles.content}>
            <h1 style={styles.title}>No Packages Available</h1>
            <p style={styles.text}>
              We’re working on exciting packages designed to give you the best value and experience. Stay tuned!
            </p>
            <img
              src="https://illustrations.popsy.co/gray/web-design.svg"
              alt="Coming Soon"
              style={styles.image}
            />
          </div>
        </div>
      ) : (
        <div className='vcdp-package-section'>
          <div className='vcdp-package-container'>
            <h2 className='vcdp-package-title'>Party Packages</h2>
            <div className='vcdp-package-list'>
              {partypackages.slice(0, 10).map((item) => (
                <Link key={item.id}
                  to={generateClubUrl(item.clubName, item.cityName, item.areaName, item.title)} className='vcdp-package-link'>
                  <PackageCard PackageData={item} />
                </Link>
              ))}

            </div>
          </div>
        </div>
      )}

    </div>
  );
});
